<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { supabase } from './lib/supabase';
import LoginView from './components/LoginView.vue';
import StudentSessions from './components/StudentSessions.vue';

const session = ref(null);
const checkingSession = ref(true);
let authListener;

onMounted(async () => {
  // getSession() can trigger a token-refresh network call if the access
  // token had expired (e.g. while offline). If that call fails — a flaky
  // connection right as the page loads — this must still fall through to
  // the login/app view instead of leaving checkingSession stuck forever.
  try {
    const { data } = await supabase.auth.getSession();
    session.value = data.session;
  } catch {
    session.value = null;
  } finally {
    checkingSession.value = false;
  }

  authListener = supabase.auth.onAuthStateChange((_event, newSession) => {
    session.value = newSession;
  }).data.subscription;
});

onUnmounted(() => {
  authListener?.unsubscribe();
});
</script>

<template>
  <div v-if="checkingSession" class="loading-screen">
    <wa-spinner></wa-spinner>
  </div>
  <StudentSessions v-else-if="session" :user="session.user" />
  <LoginView v-else />
</template>

<style scoped>
.loading-screen {
  display: flex;
  justify-content: center;
  padding-top: 20vh;
  font-size: 2rem;
}
</style>
